import { IContractListState } from '../../types/contracts/contractTypes';
import { IStaticRateContract } from '../../types/entities/IStaticRateContract';

export const adaptStaticRateContractToState = (
    raw: IStaticRateContract
): IContractListState => {
    return {
        Id: raw.Id,
        Enabled: raw.Enabled || false,
        Name: raw.Name || '',
        Description: raw.Description || '',
        IdSupplierHotel: raw.IdSupplierHotel || 0,
        SupplierHotel: raw.SupplierHotel?.Name || '',
        IdStaticRateContractStatusType:
            raw.StaticRateContractStatus?.IdStaticRateContractStatusType || 0,
        StaticRateContractStatusType:
            raw.StaticRateContractStatus?.StaticRateContractStatusType
                ?.LocalizedCaption ||
            raw.StaticRateContractStatus?.StaticRateContractStatusType
                ?.Caption ||
            raw.StaticRateContractStatus?.StaticRateContractStatusType?.Name ||
            '',
        StaticRateContractStatusColor:
            raw.StaticRateContractStatus?.StaticRateContractStatusType?.Color ||
            '',
        IdAgency: raw.IdAgency || 0,
        Agency: raw.Agency?.Name || '',
        IdSupplierHotelRatePlan: raw.IdSupplierHotelRatePlan || 0,
        SupplierHotelRatePlan: raw.SupplierHotelRatePlan?.Name || '',
        IdRateScopeModel: raw.IdRateScopeModel || 0,
        RateScopeModel:
            raw.RateScopeModel?.LocalizedCaption ||
            raw.RateScopeModel?.Caption ||
            raw.RateScopeModel?.Name ||
            '',
        RateScopeModelKey: raw.RateScopeModel?.Key || '',
        ActiveFrom: raw.ActiveFrom ? new Date(raw.ActiveFrom) : null,
        ActiveTo: raw.ActiveTo ? new Date(raw.ActiveTo) : null,
    };
};
